import React from "react";
import { TypeAnimation } from "react-type-animation";
import Slider from "react-slick";

import main0 from "../assets/profile_pics/main1.png";
import main1 from "../assets/profile_pics/main2.png";
import main2 from "../assets/profile_pics/main3.png";
import main3 from "../assets/profile_pics/main4.png";

function Hero() {
  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 100,
    fade: true,
    // cssEase: "linear",
  };
  return (
    <div
      id="top"
      className="flex flex-col md:flex-row justify-center items-center "
    >
      <div className="col-span-1 my-auto mx-auto w-72 md:w-1/3  h-auto 1g:w-[100px]">
        <Slider {...settings} arrows={false}>
          <img src={main1} alt="hero" />
          <img src={main2} alt="hero" />
          <img src={main3} alt="hero" />
          <img src={main0} alt="hero" />
        </Slider>
      </div>
      <div className="px-5 my-auto md:w-1/2">
        <h1 className="text-white text-4xl sm:text-3xl lg:text-6xl font-extrabold">
          <span className="primary-color">I'm a</span> <br />
          <TypeAnimation
            sequence={[
              "Engineer 💪",
              900,
              "Learner 🔥",
              900,
              "Coder 🧑‍💻",
              900,
              "Architect 🏛️",
              900,
              "Innovator 💡",
              900,
              "Problem Solver",
              700,
              "Collaborator 🤝",
              900,
              "Strategist 🎯",
              900,
              "Mentor 🧑‍🏫",
              900,
              "Analyst 📊",
              900,
            ]}
            wrapper="span"
            speed={50}
            repeat={Infinity}
          />
        </h1>

        <p className="text-white sm:text-sm my-6 lg:text-lg font-light italic">
          A Full Stack Developer From India 🇮🇳
        </p>

        <div className="my-8">
          <a
            href="https://drive.google.com/file/d/1gVn9n8P7yaF71Aq1aJY6Ll7-oTLvcg-n/view?usp=drive_link"
            className="px-6 py-3 w-full rounded-x1 mr-4 text-sm
            bg-gradient-to-br from-orange-500 to-pink-500 text-white uppercase"
          >
            Download CV
          </a>
          <a
            href="#links"
            className="px-6 py-3 w-full mr-4 border uppercase text-sm
             border-gray-400 hover:bg-gradient-to-br from-orange-500 to-pink-500
            text-white hover:border-none"
          >
            Contact
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
